<template>
  <div class="home">
    <IndexGuestTitlePage/>
  </div>
</template>

<script>
  import IndexGuestTitlePage from '@/components/indexGuestTitlePage.vue';

  export default {
    name: 'HomeGuestView',
    components: {
      IndexGuestTitlePage
    }
  }
</script>